// src/App.js
import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './components/LandingPage.jsx';
import FormPage from './components/FormPage.jsx';   // new wrapper page for steps
import ReviewScreen from './components/new/ReviewScreen.jsx';
import Success from './components/new/Success.jsx';
import Performance from './components/new/PerformanceClause.jsx';
import Layout from './components/new/Layout.jsx';
import Archive from './components/new/Archive.jsx';
import FloatingWidgets from './components/FloatingWidgets.jsx';
import { Analytics } from "@vercel/analytics/react"

// import Archive from './components/Archive';
// import Performance from './components/Performance';
// import EaseYourMind from './components/EaseYourMind';

export default function App() {
  return (
    <>
      <Layout>
      <FloatingWidgets />
      <Routes>
        
        <Route path="/" element={<LandingPage />} />
        
        <Route path="/archive" element={<Archive />} />
        <Route path="/about" element={<Performance />} />

        <Route path="/form/*" element={<FormPage />} />

        <Route path="/review" element={<ReviewScreen />} />
        <Route path="/success" element={<Success />} />


        <Route path="/labour" element={<Navigate to="/form/labour" replace />} />
        <Route path="/reach" element={<Navigate to="/form/reach" replace />} />
        <Route path="/value" element={<Navigate to="/form/value" replace />} />
        <Route path="/share" element={<Navigate to="/form/share" replace />} />
        <Route path="/invoice" element={<Navigate to="/form/invoice" replace />} />

        <Route path="*" element={<LandingPage />} />
      </Routes>
      </Layout>
      <Analytics/> 
    </>
  );
}
